import { api } from "api/api";
import { AxiosError } from "axios";
import Produto from "model/administracao/cadastro/produto/Produto";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import ItemNotaFiscalEntrada from "model/suprimentos/ItemNotaFiscalEntrada";
import { DataTableFilterMeta, DataTableOperatorFilterMetaData } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class RecebimentoService implements BaseServiceCadastros<ItemNotaFiscalEntrada> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/recebimento/pesquisar`;
            url += getFilters(filters);

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<ItemNotaFiscalEntrada>((resolve, reject): void => {
            api
                .get(`/recebimento/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(itemPlano: ItemNotaFiscalEntrada) {
        return new Promise<ItemNotaFiscalEntrada>((resolve, reject): void => {
            api
                .post(`/recebimento/incluir`, JSON.stringify(itemPlano))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(itemPlano: ItemNotaFiscalEntrada) {
        return new Promise<ItemNotaFiscalEntrada>((resolve, reject): void => {
            api
                .put(`/recebimento/editar`, JSON.stringify(itemPlano))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/recebimento/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getProdutos() {
        return new Promise<Array<Produto>>((resolve, reject): void => {
            api
                .get(`/recebimento/produtos`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    emitirRelatorio(id: number) {
        return new Promise<Blob>((resolve, reject): void => {
            api
                .get(`/recebimento/report/${id}`, { responseType: 'arraybuffer' })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    
}

export default RecebimentoService;